import { defaultTheme, setTheme, themeMode, useTheme, type ThemeMode } from './themes';

/** Light or dark, and the switch between Lureo's own light and dark themes, for every light/dark control outside the Themes page. */
export function useThemeMode(): { mode: ThemeMode; setMode: (mode: ThemeMode) => void; toggle: () => void } {
  const mode = themeMode(useTheme());
  const setMode = (next: ThemeMode) => setTheme(defaultTheme(next).key);
  return { mode, setMode, toggle: () => setMode(mode === 'dark' ? 'light' : 'dark') };
}
